import { Kvps } from "./kvps";
import { Session } from "next-auth";

export function hasRole(roles: number[], whitelist: number[]): boolean {
  return whitelist.some((role) => roles.includes(role));
}

export function requireKvps(kvps?: Kvps | null) {
  const eligible = kvps !== null;

  // Bare-bones implementation for now, but this might be handy in the future
  // for implementing specific checks or authorization logic.

  return { eligible };
}

export function requireRole(session: Session | null, whitelist: number[]) {
  let authorized = false;

  if (session?.user) {
    authorized = hasRole(session.user.grpRoles, whitelist);
  }

  return { authorized };
}
